import { withLayoutCsProps } from 'viewModel/content/layoutCs/withLayoutCsProps';
import LayoutCs from 'components/Content/ContentLayout/LayoutCs/LayoutCs';

export default withLayoutCsProps(LayoutCs);
